
import SystemResultsSummaryDivider from "../../../dividers/SystemResultsSummaryDivider";
import FlashResultsScore from "../../../others/courses/flash/FlashResultsScore";
import FlashResultsDetailedScores from "../../../others/courses/flash/FlashResultsDetailedScores";
import FlashResultsScoreCardContentLayout from "../../../layouts/courses/flash/FlashResultsScoreCardContentLayout";

export default function FlashResultsScoreCard({scores, total}) {
    // Used in FlashResultsTabletSummary to display flash scores
    // in desktop mode

    // BUILD
    return (
        <div className={"hidden h-[168px] min-h-[168px] w-[384px] min-w-[384px] sm:flex sm:flex-col bg-backgroundLight5 shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] rounded-[16px]"}>
            <FlashResultsScoreCardContentLayout>
                <FlashResultsScore correctAnswers={scores[0]} total={total}/>
                <SystemResultsSummaryDivider />
                <FlashResultsDetailedScores good={scores[0]}
                                            bad={scores[1]}
                                            neutral={scores[2]} />
            </FlashResultsScoreCardContentLayout>
        </div>
    );
}